import type { PrimeStyleClassNames } from "../../types";
import type { TranslateFn } from "../../i18n";
import { cx } from "../utils/classnames";
import { UploadIcon, ArrowRightIcon } from "../icons";

export function UploadView({
  selectedFile, previewUrl, dragOver, setDragOver, fileInputRef,
  handleFileSelect, handleRemovePreview, handleTryOnSubmit, cn, t,
  submitLabel,
  submitDisabled,
  submitTitle,
}: {
  selectedFile: File | null;
  previewUrl: string | null;
  dragOver: boolean;
  setDragOver: (v: boolean) => void;
  fileInputRef: React.RefObject<HTMLInputElement>;
  handleFileSelect: (file: File) => void;
  handleRemovePreview: () => void;
  handleTryOnSubmit: () => void;
  cn: PrimeStyleClassNames;
  t: TranslateFn;
  submitLabel?: string;
  submitDisabled?: boolean;
  submitTitle?: string;
}) {
  return (
    <>
      {previewUrl ? (
        <>
          <div className={cx("ps-tryon-preview", cn.preview)}>
            <div className="ps-tryon-preview-blur" style={{ backgroundImage: `url(${previewUrl})` }} />
            <img src={previewUrl} alt={t("Your photo")} className={cn.previewImage} />
            <button onClick={handleRemovePreview} className={cx("ps-tryon-preview-remove", cn.removeButton)}>&times;</button>
          </div>
          <button
            onClick={handleTryOnSubmit}
            className={cx("ps-tryon-submit", cn.submitButton)}
            disabled={submitDisabled}
            title={submitTitle}
          >
            {submitLabel || t("Try It On")} <ArrowRightIcon />
          </button>
        </>
      ) : (
        <div
          className={cx(`ps-tryon-upload${dragOver ? " ps-tryon-drag-over" : ""}`, cn.uploadZone)}
          onClick={() => fileInputRef.current?.click()}
          onDragOver={e => { e.preventDefault(); setDragOver(true); }}
          onDragLeave={() => setDragOver(false)}
          onDrop={e => { e.preventDefault(); setDragOver(false); const f = e.dataTransfer?.files?.[0]; if (f) handleFileSelect(f); }}
        >
          <input ref={fileInputRef} type="file" accept="image/jpeg,image/png,image/webp" style={{ display: "none" }}
            onChange={e => { const f = e.target.files?.[0]; if (f) handleFileSelect(f); }} />
          <UploadIcon />
          <p className={cx("ps-tryon-upload-text", cn.uploadText)}>{t("Upload a full body photo")}</p>
          <p className={cx("ps-tryon-upload-hint", cn.uploadHint)}>{t("JPEG, PNG or WebP (max 10MB)")}</p>
        </div>
      )}
    </>
  );
}
